<template>
  <div class="body">
    <div v-if="isAbc" class="abc">
    </div>
    <pageHeader>
    </pageHeader>
    <loading v-if="showLoading">
    </loading>
    <div v-if="!showLoading">
      <div>
        <card
          v-for="( item, index ) in virusTripListForRender"
          :key="index"
          :cardInfo="item">
        </card>
      </div>
      <paginator>
      </paginator>
      <notice v-if="hasVirusTrip">
      </notice>
      <copyright v-if="hasVirusTrip">
      </copyright>
      <empty v-if="!hasVirusTrip">
      </empty>
      <menuPanel v-if="showMenuPanel">
      </menuPanel>
    </div>
    <menuWindow>
    </menuWindow>
  </div>
</template>

<script>
  import pageHeader from './page-header.vue';
  import card       from './card.vue';
  import notice     from './notice.vue';
  import empty      from './empty.vue';
  import menuPanel  from './menu-panel.vue';
  import menuWindow from './menu-window.vue';
  import loading    from './loading.vue';
  import service    from '../../service/index.js';
  import paginator  from './paginator.vue';
  import copyright  from './copyright.vue';

  import { mapGetters, mapMutations, mapState } from 'vuex';

  export default {
    components : {
      pageHeader, card,       notice,  empty,
      menuPanel,  menuWindow, loading, paginator,
      copyright
    },

    data() {
      return {
        showLoading : true
      };
    },

    computed : {
      ...mapState( 'virusTrip', [ 'pageNumber', 'pageCount', 'pageLoading' ] ),

      ...mapGetters( 'virusTrip', [ 'virusTripList' ] ),

      virusTripListForRender() {
        const startIndex = this.pageNumber * this.pageCount;
        const endIndex   = startIndex + this.pageCount;

        return this.virusTripList.slice( 0, endIndex );
      },

      hasVirusTrip() {
        return this.virusTripList.length;
      },

      showMenuPanel() {
        return this.virusTripList.length > 5;
      },

      isLastPage() {
        return (
          this.pageNumber === Math.floor(
            this.virusTripList.length / this.pageCount
          )
        );
      },

      isAbc() {
        const ptid = JSON.parse( localStorage.getItem( 'ptid' ) );

        return ptid === 'ABC';
      }
    },

    methods : {
      ...mapMutations( 'virusTrip', [
        'initStore',          'updateShowMenuWindow', 'updateAllVirusTrip',
        'updateUpdateTime',   'updateSearchType',     'updateSearchDate',
        'updateTravelNumber', 'updateCity',           'updatePageLoading',
        'updatePageNumber',   'updateIdList',         'updateIdVirusTrip'
      ] ),

      setPageTitle( title ) {
        document.title = title;
      },

      setPageColor( color ) {
        document.body.style.backgroundColor = color;
      },

      resumeStore() {
        const virusTripStore = JSON.parse(
          localStorage.getItem( 'virusTripStore' )
        );

        localStorage.removeItem( 'virusTripStore' );

        if ( virusTripStore && virusTripStore.virusTrip ) {
          this.initStore( virusTripStore.virusTrip );
        }
      },

      loading() {
        this.showLoading = true;

        setTimeout( () => {
          this.showLoading = false;
        }, 800 );
      },

      loadNextPage() {
        if ( !this.isLastPage ) {
          this.updatePageNumber( this.pageNumber + 1 );
        }

        this.updatePageLoading( false );

        window.pageLoading = false;
      }
    },

    created() {
      this.resumeStore();

      const { updatePageLoading, loadNextPage } = this;
      const that = this;

      window.pageLoading = false;

      window.onscroll = function() {
        const scrollTop
          = document.documentElement.scrollTop || document.body.scrollTop;

        const windowHeight
          = document.documentElement.clientHeight || document.body.clientHeight;

        const scrollHeight
          = document.documentElement.scrollHeight || document.body.scrollHeight;

        if (
          windowHeight + scrollTop + 160 >= scrollHeight && !window.pageLoading
        ) {
          if ( !that.isLastPage ) {
            window.pageLoading = true;
            updatePageLoading( true );

            setTimeout( () => {
              loadNextPage();
            }, 400 );
          }
        }
      };
    },

    mounted() {
      this.setPageTitle( '查询结果' );
      this.setPageColor( '#f4f4f4' );
      this.updateShowMenuWindow( false );

      const query = this.$route.query;

      if ( query.searchType ) {
        this.updateSearchType( query.searchType );
      }

      if ( query.searchDate ) {
        this.updateSearchDate( query.searchDate );
      }

      if ( query.travelNumber ) {
        this.updateTravelNumber( query.travelNumber );
      }

      if ( query.city ) {
        this.updateCity( query.city );
      }

      if ( query.ids ) {
        const idList = query.ids.split( ',' ).map( ( item ) => {
          return parseInt( item );
        } );

        this.updateIdList( idList );

        service.queryVirusTripById( query.ids ).then( ( data ) => {
          this.updateIdVirusTrip( data.list );
        } );
      }

      console.log( query );

      this.showLoading = true;

      if ( this.virusTripList.length === 0 && !query.ids ) {
        service.queryVirusTrip().then( ( result ) => {
          this.showLoading = false;

          if ( result && result.list ) {
            this.updateAllVirusTrip( result.list );
            this.updateUpdateTime( result.updatetime );
          }
        } );
      } else {
        this.loading();
      }
    }
  };
</script>

<style scoped lang="scss">
  @import "./index.scss";
</style>



// WEBPACK FOOTER //
// src/projects/virusTrip/pages/searchResult/index.vue